import { ButtonInterface } from 'common/types/entities/button-interface'
import { CustomFontProperties } from 'common/utils/fontsUtils'

export function getButtonFontProperties(
  entity: Pick<
    ButtonInterface,
    | 'textFontFamily'
    | 'textFontStyle'
    | 'textFontWeight'
    | 'mobileTextFontFamily'
    | 'mobileTextFontStyle'
    | 'mobileTextFontWeight'
    | 'subTextFontFamily'
    | 'subTextFontStyle'
    | 'subTextFontWeight'
    | 'mobileSubTextFontFamily'
    | 'mobileSubTextFontStyle'
    | 'mobileSubTextFontWeight'
  >,
) {
  const fontProperties = []

  if (entity.textFontFamily) {
    fontProperties.push({
      fontFamily: entity.textFontFamily,
      fontStyle: entity.textFontStyle,
      fontWeight: entity.textFontWeight,
    })
  }

  if (entity.mobileTextFontFamily) {
    fontProperties.push({
      fontFamily: entity.mobileTextFontFamily,
      fontStyle: entity.mobileTextFontStyle,
      fontWeight: entity.mobileTextFontWeight,
    })
  }

  if (entity.subTextFontFamily) {
    fontProperties.push({
      fontFamily: entity.subTextFontFamily,
      fontStyle: entity.subTextFontStyle,
      fontWeight: entity.subTextFontWeight,
    })
  }

  if (entity.mobileSubTextFontFamily) {
    fontProperties.push({
      fontFamily: entity.mobileSubTextFontFamily,
      fontStyle: entity.mobileSubTextFontStyle,
      fontWeight: entity.mobileSubTextFontWeight,
    })
  }

  return fontProperties
}

export function getNewButtonCustomFontProperties(
  entity: Pick<
    ButtonInterface,
    | 'textFontFamily'
    | 'textFontFileId'
    | 'mobileTextFontFamily'
    | 'mobileTextFontFileId'
    | 'subTextFontFamily'
    | 'subTextFontFileId'
    | 'mobileSubTextFontFamily'
    | 'mobileSubTextFontFileId'
  >,
) {
  const fontProperties: CustomFontProperties[] = []

  if (entity.textFontFamily && entity.textFontFileId) {
    fontProperties.push({
      fontFamily: entity.textFontFamily,
      fontFileId: entity.textFontFileId,
    })
  }

  if (entity.mobileTextFontFamily && entity.mobileTextFontFileId) {
    fontProperties.push({
      fontFamily: entity.mobileTextFontFamily,
      fontFileId: entity.mobileTextFontFileId,
    })
  }

  if (entity.subTextFontFamily && entity.subTextFontFileId) {
    fontProperties.push({
      fontFamily: entity.subTextFontFamily,
      fontFileId: entity.subTextFontFileId,
    })
  }

  if (entity.mobileSubTextFontFamily && entity.mobileSubTextFontFileId) {
    fontProperties.push({
      fontFamily: entity.mobileSubTextFontFamily,
      fontFileId: entity.mobileSubTextFontFileId,
    })
  }

  return fontProperties
}
